module.exports = Backbone.Collection.extend({
	url: function() {
		return App.apiRoot + 'societies/pools'
	},

	comparator: function(obj) {
		return ((obj.get('pools').length) ? 0 : 1) + obj.get('description')
	}
})
